// extracted by mini-css-extract-plugin
export var content = "ScheduledDemoInfo-module--content--a6b99";
export var info = "ScheduledDemoInfo-module--info--bd128";
export var suptitle = "ScheduledDemoInfo-module--suptitle--6f9b0";
export var title = "ScheduledDemoInfo-module--title--73fe8";
export var wrapper = "ScheduledDemoInfo-module--wrapper--7d02b";